
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoshirdicab() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab',
        heading: 'Meghana Cab : Pune to Shirdi Cab ',
        headingDescription: 'Meghana Cab offers Pune to Shirdi Cab services, ensuring a comfortable, safe, and convenient journey to the holy Sai Baba Temple. Covering a distance of approximately 185 kilometers, our reliable cabs and professional drivers provide a smooth ride through scenic routes, making your pilgrimage or weekend trip stress-free. Choose from our fleet of air-conditioned sedans, SUVs, and tempo travellers, all equipped for long-distance comfort. Whether you’re planning a one-way trip, same-day return, or overnight stay, Meghana Cab offers flexible packages, transparent pricing, and 24×7 support. Book your Pune to Shirdi Cab with Meghana Cab and travel peacefully with comfort, devotion, and reliability.',


        top: 'Top Places to Visit in Shirdi with Meghana Cab',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "Sai Baba Samadhi Mandir is the holiest shrine in Shirdi, where the mortal remains of Shri Sai Baba rest in eternal peace. Built from pristine white marble by a devotee from Nagpur, this temple is the spiritual heart of the town. The serene sanctum houses Baba’s life-sized idol, adorned with golden crowns and silk robes, radiating compassion and calm. Daily aartis, bhajans, and rituals create an atmosphere filled with devotion and love. Millions of devotees from around the world visit throughout the year to seek blessings, healing, and guidance. The divine vibration of this sacred space makes it one of India’s most visited pilgrimage destinations."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai Mosque is the sacred place where Sai Baba lived for over 60 years, blessing countless devotees and transforming Shirdi into a spiritual haven. It is here that Baba performed miracles, healed the sick, and taught lessons of unity and faith. The mosque still preserves the sacred dhuni (eternal fire) lit by Baba himself, from which sacred ash (udi) is distributed to visitors. The blackened walls, stone benches, and Baba’s oil lamps stand as timeless symbols of his humility and divine power. Dwarkamai’s tranquil energy evokes deep devotion, reminding pilgrims that true spirituality lies in compassion and service."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi, located near Dwarkamai, holds a special place in Sai Baba’s life as it was his resting place every alternate night during his later years. The small building still preserves the bed, chair, and wooden platform associated with Baba’s daily rituals. Each Thursday, a grand procession called ‘Palki Utsav’ takes place from Dwarkamai to Chavadi, where Baba’s portrait is carried amid chants, lights, and music. This event replicates the historical journey and continues to be a highlight for pilgrims. The divine atmosphere, devotional songs, and sense of continuity make visiting Chavadi an emotionally uplifting experience for all devotees."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning ‘Seat of the Guru’, is the site where Sai Baba was first spotted meditating under a neem tree as a young ascetic. It marks the spiritual origin of Baba’s presence in Shirdi. Today, a small shrine with a marble idol of Sai Baba and a sacred neem tree stand here, radiating calm and purity. Devotees believe that the leaves of this neem tree carry healing powers. The fragrance of incense, ringing bells, and the sight of devotees in deep prayer create a tranquil environment. Gurusthan is the perfect spot to connect with Baba’s earliest teachings of humility, patience, and devotion."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden that was personally tended by Sai Baba every day. It was here that Baba watered plants, meditated, and met devotees in quiet reflection. The highlight of Lendi Baug is the Nanda Deep, an ever-burning lamp placed in a small underground chamber, said to have been lit by Baba himself. Surrounded by lush greenery, fountains, and flower beds, the garden symbolizes simplicity, selfless service, and the nurturing spirit of Baba’s teachings. The peaceful ambiance provides a perfect retreat for visitors seeking spiritual solace amidst nature."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is one of the oldest shrines in Shirdi and holds immense historical significance. It was here that the priest Mhalsapati first greeted Sai Baba with the words 'Aao Sai', giving him the name by which the world knows him today. Dedicated to Lord Khandoba, a form of Lord Shiva, this temple is revered by both Sai devotees and local worshippers. The simple architecture and divine aura reflect the unity of faith that Baba always preached. The temple stands as a reminder of the sacred moment that marked the beginning of Sai Baba’s divine journey in Shirdi."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a unique theme park that beautifully recreates important moments from Sai Baba’s life and the early days of Shirdi. Spread across lush greenery, it combines spirituality with cultural storytelling. Life-size statues, traditional village huts, and dioramas depict scenes such as Baba distributing udi, blessing devotees, and sitting under the neem tree. There’s also a small amusement area for children, making it a wholesome family destination. The peaceful environment and artistic representation of Shirdi’s history make it a wonderful blend of devotion, culture, and learning."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Located just a few minutes from the temple complex, Wet N Joy Water Park offers a refreshing recreational break for families visiting Shirdi. With multiple water slides, a wave pool, and kids’ zones, it provides a fun escape after spiritual exploration. The park maintains international safety standards and offers food courts and resting areas for visitors. Its proximity to the temple makes it a popular weekend stop for families and groups. Combining spirituality and leisure, it ensures that Shirdi appeals to both pilgrims and travelers looking for a wholesome experience."
  },
  {
    "title": "Upasani Maharaj Ashram (Sakori)",
    "description": "Situated about 5 km from Shirdi in the village of Sakori, this ashram was founded by Upasani Maharaj, a devoted disciple of Sai Baba. Known for his deep spiritual wisdom and simple lifestyle, Upasani Maharaj carried forward Baba’s teachings of service, devotion, and humility. The ashram complex includes meditation halls, temples, and residential quarters for seekers. Visitors experience profound peace here, away from the bustling crowds of Shirdi. The serene atmosphere and ongoing charitable work reflect the continuation of Sai Baba’s legacy of spiritual upliftment and compassion."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located around 70 km from Shirdi, Shani Shingnapur is one of India’s most unique and revered temples dedicated to Lord Shani (Saturn). The idol is a self-manifested black stone, worshipped in open air without a roof—symbolizing the power of transparency and truth. The village is famous for having no doors or locks on houses, as residents believe Lord Shani protects them from theft and harm. Devotees visit this temple to seek relief from planetary afflictions and to embrace honesty in life. A trip to Shirdi is considered incomplete without visiting this divine site of faith and fearlessness."
  }
],


      "services": [
    {
      "name": "Pune to Shirdi Taxi",
      "description": "Book a comfortable and reliable Pune to Shirdi taxi with Meghana Cab for your spiritual journey to Sai Baba Temple. Our taxis are available for one-way, round-trip, and custom travel packages. With professional drivers, air-conditioned vehicles, and flexible scheduling, we ensure a peaceful ride for devotees and families traveling from Pune to Shirdi."
    },
    {
      "name": "Pune to Shirdi Cab Package",
      "description": "Experience a hassle-free pilgrimage with Meghana Cab’s Pune to Shirdi cab package. This all-inclusive package includes door-to-door pickup, AC cabs, and flexible return options. Choose from vehicles like Sedan, Ertiga, and Innova Crysta based on your group size and comfort needs. Ideal for devotees seeking a convenient trip to Sai Baba Temple with affordable rates and professional service."
    },
    {
      "name": "Pune to Shirdi Cab Charges",
      "description": "Meghana Cab offers transparent and affordable cab charges from Pune to Shirdi. Enjoy cost-effective fares with no hidden fees and flexible options for one-way or round trips. Our pricing depends on your vehicle choice and trip duration, ensuring you get the best value for your travel budget."
    },
    {
      "name": "Pune to Shirdi Cab Fare",
      "description": "Get competitive cab fare for your Pune to Shirdi trip with Meghana Cab. Whether you prefer a sedan, SUV, or luxury Innova Crysta, we offer budget-friendly fares that include tolls, driver allowances, and taxes. Enjoy safe and reliable service to one of India’s most visited pilgrimage destinations."
    },
    {
      "name": "Pune to Shirdi Cab One Way",
      "description": "Book a one-way cab from Pune to Shirdi with Meghana Cab for flexible and affordable travel. Perfect for devotees planning a single drop-off at Shirdi, our service provides punctual pickups, air-conditioned cars, and professional drivers for a relaxed and timely journey."
    },
    {
      "name": "Pune to Shirdi Taxi Fare",
      "description": "Meghana Cab offers the most reasonable taxi fare from Pune to Shirdi with transparent billing. Choose from a wide range of vehicles and travel packages. Our fares are designed to fit every budget without compromising on comfort or safety during your pilgrimage journey."
    },
    {
      "name": "Pune to Shirdi Cab Service",
      "description": "Travel comfortably with Meghana Cab’s reliable Pune to Shirdi cab service. We specialize in safe, on-time, and smooth travel for pilgrims heading to the Sai Baba Temple. Our service includes door-to-door pickup, clean cars, and courteous drivers for a stress-free religious experience."
    },
    {
      "name": "Pune to Shirdi Cab Booking Service",
      "description": "Book your Pune to Shirdi cab easily through Meghana Cab’s seamless booking service. Enjoy quick online reservations, instant confirmations, and 24x7 customer support. Choose from economy sedans, spacious SUVs, or premium cabs for your Shirdi pilgrimage trip."
    },
    {
      "name": "Pune to Shirdi Taxi Drop",
      "description": "Need a direct drop at Shirdi? Meghana Cab offers one-way taxi drop services from Pune to Shirdi at affordable rates. Our drivers ensure a comfortable ride with on-time arrival at your destination, perfect for devotees heading straight to Sai Baba Temple or nearby accommodations."
    },
    {
      "name": "Pune Airport to Shirdi Cab",
      "description": "Arriving by flight? Meghana Cab provides Pune Airport to Shirdi cab services with convenient pickups right from the airport. Our fleet includes sedans, Ertiga, and Innova cabs, offering safe and comfortable transfers to Shirdi at transparent fares. Ideal for solo travelers, families, and groups."
    },
    {
      "name": "Pune to Shirdi Car Rental",
      "description": "Meghana Cab offers affordable car rental services from Pune to Shirdi. Rent your preferred vehicle type—sedan, Ertiga, or Innova—for a day or multi-day trip. Enjoy flexible itineraries, AC comfort, and reliable service for your Sai Baba Temple visit."
    },
    {
      "name": "Pune to Shirdi Cab Booking",
      "description": "Easily book your cab from Pune to Shirdi with Meghana Cab. Our user-friendly booking process and responsive support team ensure a quick and reliable service. Whether it’s a family trip or a solo pilgrimage, our cabs are available round the clock for your convenience."
    },
    {
      "name": "Pune to Shirdi Cab Price",
      "description": "Get the best cab prices from Pune to Shirdi with Meghana Cab. Our transparent pricing policy ensures you pay only what’s quoted. Choose from affordable sedan options or premium SUVs for a smooth and comfortable journey to the Sai Baba Temple."
    },
    {
      "name": "Pune to Shirdi Car Package",
      "description": "Plan your Shirdi trip with Meghana Cab’s exclusive car packages from Pune. Our packages include cab transfers, driver allowances, and flexible return options. Whether you’re planning a same-day visit or an overnight stay, we provide comfortable and well-priced travel options."
    },
    {
      "name": "Pune Airport to Shirdi Cab Fare",
      "description": "Check competitive Pune Airport to Shirdi cab fares with Meghana Cab. We offer economical rates for direct airport-to-temple transfers with air-conditioned vehicles and friendly drivers. Ideal for travelers arriving at Pune Airport for a quick journey to Shirdi."
    },
    {
      "name": "Pune to Shirdi Cab Cost",
      "description": "Find cost-effective Pune to Shirdi cab options with Meghana Cab. Our cab cost covers all essentials—fuel, driver allowance, and tolls—so there are no hidden charges. Choose a one-way or round-trip plan based on your travel schedule."
    },
    {
      "name": "Cab Service from Pune to Shirdi",
      "description": "Choose Meghana Cab’s trusted cab service from Pune to Shirdi for a smooth and spiritual journey. Our professional drivers, well-maintained cabs, and flexible timings make every trip comfortable and convenient. Perfect for family pilgrims and solo devotees."
    },
    {
      "name": "Pune to Shirdi Cabs Round Trip",
      "description": "Plan your round trip from Pune to Shirdi and back with Meghana Cab’s reliable service. We offer flexible schedules, comfortable vehicles, and reasonable pricing for return journeys. Perfect for same-day travel or overnight stays in Shirdi."
    },
    {
      "name": "Shirdi to Pune Cab",
      "description": "Book your return cab from Shirdi to Pune with Meghana Cab. Enjoy safe, comfortable, and timely service with experienced drivers who know the route well. Choose from a variety of cars and enjoy affordable one-way return fares."
    },
    {
      "name": "Taxi Service from Pune to Shirdi",
      "description": "Meghana Cab provides the most dependable taxi service from Pune to Shirdi for devotees visiting the Sai Baba Temple. Our well-maintained vehicles, punctual service, and courteous drivers make your journey serene and worry-free. Enjoy flexible booking and transparent fares for all trip types."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Taxi", "Pune to Shirdi Cab Package"],
    ["Pune to Shirdi Cab Charges", "Pune to Shirdi Cab Fare"],
    ["Pune to Shirdi Cab One Way", "Pune to Shirdi Taxi Fare"],
    ["Pune to Shirdi Cab Service", "Pune to Shirdi Cab Booking Service"],
    ["Pune to Shirdi Taxi Drop", "Pune Airport to Shirdi Cab"],
    ["Pune to Shirdi Car Rental", "Pune to Shirdi Cab Booking"],
    ["Pune to Shirdi Cab Price", "Pune to Shirdi Car Package"],
    ["Pune Airport to Shirdi Cab Fare", "Pune to Shirdi Cab Cost"],
    ["Cab Service from Pune to Shirdi", "Pune to Shirdi Cabs Round Trip"],
    ["Shirdi to Pune Cab", "Taxi Service from Pune to Shirdi"]
  ],










"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Shirdi Cab Service",
        "WhyChoosedescription": "Meghana Cab offers trustworthy and comfortable cab services from Pune to Shirdi, making your visit to the holy Sai Baba temple smooth and convenient."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop at Shirdi",
        "WhyChoosedescription": "We ensure on-time pick-up from Pune and prompt drop at Shirdi, so you can attend darshan and rituals without any travel delays."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Pilgrimage Routes",
        "WhyChoosedescription": "Our drivers are well-versed with the Pune to Shirdi route and understand the importance of a safe, peaceful, and comfortable religious journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Meghana Cab offers budget-friendly fares with no hidden charges, giving you clear and upfront pricing for your Shirdi travel."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Vehicles",
        "WhyChoosedescription": "Travel in well-maintained, sanitized cabs equipped with safety features like GPS, seat belts, and 24/7 emergency support for a safe journey."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability for Shirdi Trips",
        "WhyChoosedescription": "Whether it’s an early morning darshan or a late-night return, Meghana Cab provides round-the-clock service for Pune to Shirdi travel."
    },
    {
        "WhyChooseheading": "Customizable Travel Options",
        "WhyChoosedescription": "Choose from one-way, round-trip, or include nearby locations like Shani Shingnapur in your customized cab package."
    },
    {
        "WhyChooseheading": "Simple Online Booking and Devotee Support",
        "WhyChoosedescription": "Easily book your Pune to Shirdi cab via our website or app. Our support team is available to help with bookings and any spiritual travel queries."
    }
]


























    }






const faqData = [
    {
        question: "How can I book a Pune to Shirdi cab with Meghana Cab?",
        answer: "You can book a Pune to Shirdi cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Shirdi?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Shirdi trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one‑way cab service available from Pune to Shirdi?",
        answer: "Yes, we offer both one‑way and round‑trip cab services from Pune to Shirdi."
    },
    {
        question: "How long does it take to travel from Pune to Shirdi by cab?",
        answer: "The journey covers about **180‑190 km** by road and usually takes **4 to 5 hours**, depending on traffic and route selected. :contentReference[oaicite:0]{index=0}"
    },
    {
        question: "What is the approximate fare for a Pune to Shirdi cab?",
        answer: "Fare depends on cab type, route, and inclusions (like tolls). For instance, a hatchback one‑way fare is around ₹2,000‑₹3,500. :contentReference[oaicite:1]{index=1}"
    },
    {
        question: "Are tolls, parking, and taxes included in the cab fare from Pune to Shirdi?",
        answer: "Tolls, parking fees, and state taxes are usually additional and will be clearly communicated during booking."
    },
    {
        question: "Are Meghana Cab drivers experienced for outstation travel like Pune to Shirdi?",
        answer: "Yes, our drivers are professional, experienced, and familiar with routes to Shirdi and similar pilgrimage destinations."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Shirdi journey?",
        answer: "Yes, you can request halts or breaks during the trip. Please inform us while booking."
    },
    {
        question: "Is the cab service from Pune to Shirdi available at night?",
        answer: "Yes, Meghana Cab offers 24/7 service, so you can schedule your journey according to your convenience."
    },
    {
        question: "What payment options are accepted for Pune to Shirdi cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Shirdi cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The trip to Shirdi with Meghana Cab was seamless. The driver left early, the ride was smooth, and we reached in good time.”',
    },
    {
        name: 'Mrs. Sneha Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very happy with Meghana Cab’s Pune‑to‑Shirdi service. The vehicle was clean, the driver helpful and courteous, and pricing was fair.”',
    },
];














































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab",
  "description": "Book Pune to Shirdi cab service with Meghana Cabs for hassle-free travel. Affordable one-way and round-trip taxi packages, reliable car rentals, and airport transfers. Comfortable and timely rides for your pilgrimage or trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4502"
  }
};







    return (
        <div>


<Helmet>
  <title>Pune to Shirdi Cab | Reliable Taxi Service & Packages @ Meghana Cabs</title>
  <meta
    name="description"
    content="Get Pune to Shirdi cab service with Meghana Cabs. Affordable taxi packages, airport transfers, one-way and round trip options. Book your reliable cab for a comfortable journey."
  />
  <meta
    name="keywords"
    content="Pune to shirdi taxi, Pune to shirdi cab package, pune to shirdi cab charges, pune to shirdi cab fare, Pune to shirdi cab one way, pune to shirdi taxi fare, pune to shirdi cab service, Pune to shirdi cab booking service, Pune to shirdi taxi drop, Pune airport to shirdi cab, pune to shirdi car rental, pune to shirdi cab booking, pune to shirdi cab price, pune to shirdi car, cab service from pune to shirdi, pune to shirdi cab booking rates, pune airport to shirdi taxi, pune to shirdi cab service rates, pune to shirdi package by car, pune to shirdi cabs round trip, pune airport to shirdi cab price, pune airport to shirdi airport, pune airport to shirdi cab fare, pune airport to shirdi cab service, pune to shirdi cab cost, pune to shirdi car package, Pune to shirdi taxi charges, Shirdi pune cab, Taxi service from pune to shirdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/68.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoshirdicab;